$('.all-div-flex').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
});


$(".flex-text").click(function() {
    $(".paragraph-accor").css("display","block");
});

$(".video-sec").click(function() {
    $(".play-button").css("display","none");
});


if ($(window).width() < 768)
    {
$('.first-col-innre').slick({
 infinite: false,
    arrows: false,
  slidesToShow: 3,
    autoplay: false,
    autoplayspeed: 2000,
    dots: false,
    centerMode: false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        dots: true,
       slidesToShow: 1,
        slidesToShow: 1
      }
    }
  ]
});
       }

